export const register = {
    title: 'Đăng ký',
    passwordLabel: 'Mật khẩu',
    confirmPassword: 'Nhập lại mật khẩu',
    buttonRegister: 'Đăng ký',
    confirmPasswordLabel: 'Nhập lại mật khẩu',
    policy1: 'Tôi đồng ý với các',
    policy2: 'Điều khoản & Điều kiện',
    and: 'và',
    policy3: 'Chính sách bảo mật.',
    backToLogin: 'Quay lại đăng nhập',
    contentAfterRegister:
        'Chúc mừng bạn đã đăng ký thành công! Vui lòng kiểm tra email của bạn để xác minh tài khoản. Nếu bạn không thấy email xác minh trong hộp thư đến, vui lòng kiểm tra hộp thư Spam.',
};
